import { useState } from "react";
import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import AddAttachmentsFolderForm from "../../Forms/AddAttachmentsFolderForm/AddAttachmentsFolderForm";

const AttachmentsFolderModal = (props) => {
  const formName = "AttachmentsFolderModal";
  const [step, setStep] = useState(0);
  const { handleHide, show, title } = props;
  const { t } = useTranslation();
  const [steps, setSteps] = useState([
    { title: t("global:attachments.folderOption"), error: false },
  ]);

  const [isSubmit, setIsSubmit] = useState(false);

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          bmxclass="Success"
          form={formName}
          onClick={() => setIsSubmit(true)}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"450px"}
      height={"300px"}
      onClose={handleHide}
      buttons={buttons()}
      steps={steps}
      header={title}
    >
      <AddAttachmentsFolderForm
        isSubmit={isSubmit}
        step={step}
        steps={steps}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        formName={formName}
        handleHide={handleHide}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "AttachmentsFolderModal" })(
  AttachmentsFolderModal
);
